import React from "react";
import { firebaseConnect } from "react-redux-firebase";
import CarouselNewsItem from "./Components/CarouselNewItem/CarouselNewsItem";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Spinner from "../../Spinner/Spinner";
import Error from "../../Error/error";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 924 },
    items: 1,
    paritialVisibilityGutter: 60,
  },
  tablet: {
    breakpoint: { max: 924, min: 600 },
    items: 1,
    paritialVisibilityGutter: 50,
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
    paritialVisibilityGutter: 0,
  },
};

class CarouselNews extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      error: false,
      featured: [],
    };
  }
  componentDidMount() {
    const docRef = this.props.firebase
      .firestore()
      .collection("products")
      .where("kKA9QFQMTCpRRNejqhJm", "==", true);

    docRef
      .get()
      .then((querySnapshot) => {
        const featured = [];
        querySnapshot.forEach((doc) => {
          const {
            kKA9QFQMTCpRRNejqhJm,
            TBoOE7IP7M9KMAerR7ck,
            images,
            name,
            code,
            price,
            position,
          } = doc.data();
          featured.push({
            id: doc.id,
            images,
            name,
            code,
            price,
            kKA9QFQMTCpRRNejqhJm,
            TBoOE7IP7M9KMAerR7ck,
            position,
          });
        });

        featured.sort((a, b) => {
          return a.position - b.position;
        });

        if (featured.length) {
          this.setState(() => ({ loading: false, featured, error: false }));
        } else {
          this.setState(() => ({ loading: false, error: true }));
        }
      })
      .catch((error) => {
        this.setState({ error: true, loading: false });
      });
  }

  render() {
    const { featured, loading, error } = this.state;

    let message;
    if (loading) {
      message = <Spinner />;
    } else if (error) {
      message = <Error />;
    } else {
      message = (
        <div>
          <div className="text-center pb-5">
            <h2 className="font-weight-bold">Diseños Favoritos</h2>
          </div>
          <Carousel
            itemClass="image-item"
            draggable={true}
            swipeable={true}
            autoPlay={true}
            infinite={true}
            responsive={responsive}
            className="carousel z-index"
          >
            {featured.map((array) => (
              <center key={array.id}>
                <CarouselNewsItem array={array} />
              </center>
            ))}
          </Carousel>
        </div>
      );
    }

    return <>{message}</>;
  }
}

export default firebaseConnect()(CarouselNews);
